/* @jsxImportSource react */

import * as React from 'react';

const PriceReductionFlag = ({
  children,
  ...props
}: React.HTMLAttributes<Omit<HTMLSpanElement, 'className'>>) => (
  <span
    className="text-size-body-xs bg-color-sale text-color-sale-contrasttext ml-0.5 inline-flex h-2 shrink-0 grow-0 items-center justify-start rounded-sm px-1 group-[&:has(.price-voucher-discount)]:hidden empty:hidden"
    {...props}
  >
    {children}
  </span>
);

PriceReductionFlag.displayName = 'PriceReductionFlag';

export { PriceReductionFlag };
